function SongPanel(props: { id: string; title?: string; levels?: number[] }) {
    return (<div className="parent h-36 w-32 flex flex-col justify-center">
        <div className="flex justify-center"><img src={process.env.PUBLIC_URL+"/images/jacket/jacket_"+props.id+'.png'} width="120px" alt={props.title || props.id}
            onError={e => { const fallback = `${process.env.PUBLIC_URL}/images/jacket-placeholder.svg`; if (!e.currentTarget.src.endsWith('jacket-placeholder.svg')) e.currentTarget.src = fallback; }} /></div>
        <p className="text-xs truncate px-1" title={props.title}>{props.title}</p>
        <div className="hiddenChild">
            {[1,2,3].map(level => <button key={level} disabled={!(props.levels ?? [1,2,3]).includes(level)}
                className={`text-base h-5 w-5 m-1 disabled:opacity-30 ${['bg-yellow-300','bg-orange-300','bg-red-300'][level-1]}`}
                onClick={() => {window.location.href='#/Chart?id='+props.id+'&level='+level}}>{['N','H','A'][level-1]}</button>)}
        </div>
    </div>)
}

export default SongPanel;
